import { render, staticRenderFns } from "./ChallengeV2Settings.vue?vue&type=template&id=cc5e6ddc&scoped=true"
import script from "./ChallengeV2Settings.vue?vue&type=script&lang=js"
export * from "./ChallengeV2Settings.vue?vue&type=script&lang=js"
import style0 from "./ChallengeV2Settings.vue?vue&type=style&index=0&id=cc5e6ddc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5e6ddc",
  null
  
)

export default component.exports